import { mixpanel } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { MIXPANEL_PAGE_NAME, DEFAULT_PAGE } from '../../constants';
import { PAGE_VIEWED } from './constants';

export const sendMixpanelTrackEvent = ({ eventName, params }) => {
    const {
        userId,
        pathParameters: { id },
        queryParameters: { page = DEFAULT_PAGE },
    } = getContext();
    const pageNumber = parseInt(page, 10);

    const sharedData = {
        'User id': userId,
        'Tag name': id,
        'Page name': MIXPANEL_PAGE_NAME,
        'Page number': pageNumber,
        ...params,
    };

    if (eventName === PAGE_VIEWED) {
        mixpanel.trackPageView({
            'Page Name': MIXPANEL_PAGE_NAME,
            ...sharedData,
            ...params,
        });
    } else {
        mixpanel.track(eventName, { ...sharedData, ...params });
    }
};
